import React from "react";
import { Route, Routes } from "react-router-dom";
import { authRoutes, privateRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Auth Routes */}
      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <PublicRoute>
                {route.element}
              </PublicRoute>
            }
          />
        ))}
      </Route>

      {/* Private Routes */}
      <Route element={<Feature />}>
        {privateRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <PrivateRoute allowedRoles={route.allowedRoles}>
                {route.element}
              </PrivateRoute>
            }
          />
        ))}
      </Route>
    </Routes>
  );
};

export default ALLRoutes;
